module.exports = __webpack_public_path__ + "img/epa_logo.db1407af.png";